<template>
  <article class="user_view">
    <left-menu/>
    <select-device @cancel="onCancel" :typeSelection="'single'" :company="selectedCompany" @select="onSelect" v-if="showModal"/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Devices' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Editar dispositivo</h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre</label>
            <input v-model="device.name" disabled placeholder="Nombre"/>
          </div>
          <!--div class="form_input">
            <label>IMEI</label>
            <input v-model="device.imei" placeholder="Número IMEI"/>
          </div-->
          <div class="form_input">
            <label>Número de teléfono</label>
            <input v-model="device.sim" type="number" placeholder="Número de sim (teléfono)"/>
          </div>
          <div class="form_input" v-if="getRol() == 'admin' || getRol() == 'coord'">
            <label>Empresa</label>
            <input style="cursor: pointer;" v-model="device.company" @click="showModal = true" placeholder="Seleccione"/>
          </div>
        </div>
        <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" :class="{'click':isCreated,'active': isComplete()}" @click.prevent="editDev" :style="{width: '160px', height:'46px'}">GUARDAR</button>
      </section>
    </section>
  </article>
</template>

<script>

export default {
  data(){
    return{
      isCreated:false,
      errorMessage:"",
      device: {
        name: '',
        sim: '',
        company:'',
        
      },
      nit:'',
      showModal: false,
      selectedCompany:{
        id: null,
        name: null,
        nit: null
      },
      
    }
  },
  methods:{
      editDev(){
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
            edit: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'},
                           
        };
        this.resource= this.$resource('devices/'+ this.$route.params.id,{},customActions);
        this.resource.edit({
          device:{
            name: this.device.name,
            number:this.device.sim,
            
          },
          company: this.nit,
          user: this.getUserInfo().id
        })
        .then(function(data){
          this.$router.push({ name: 'Devices' });
        }).catch(function(err){
          var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
          if (JSON.parse(err.bodyText).errors[errorlog][0]){
            if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
              this.errorMessage="El número de teléfono ya se encuentra registrado"             
            }else{
              this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
            }
          }else{
            this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
          }
        
        });
      },
      isComplete(){
        if(this.device.name!='' && this.device.sim!=''){
          return true;
        }
        
      },
      onCancel(value){
        this.showModal = value;
      },
      onSelect(value){
        this.showModal = false;
        this.selectedCompany =value;
        this.nit = value.nit
        this.device.company = value.name;
        
      },
      
    },
    created(){
        
        const customActions={
            get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                
        };
        this.resource= this.$resource('devices/new',{},customActions);

        this.resource = this.resource.get({"number": this.$route.params.id})
        .then(function(data){
          this.device.sim = data.body.number;
          this.device.name = data.body.name;
          this.device.company = data.body.company.name;
          this.nit = data.body.company.nit;
          this.selectedCompany = data.body.company;
        });
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/EditDevice.vue